import { LinkWithTitle } from '@/components/links';
import { CHANNELSIDE_DISTRICT_TITLE } from '@/pages/areas/channelside-district';
import { DAVIS_ISLAND_TITLE } from '@/pages/areas/davis-island';
import { DOWNTOWN_TAMPA_TITLE } from '@/pages/areas/downtown-tampa';
import { HARBOUR_ISLAND_TITLE } from '@/pages/areas/harbour-island';
import { SOUTH_TAMPA_TITLE } from '@/pages/areas/south-tampa';
import { TAMPA_TITLE } from '@/pages/areas/tampa';
import { UNIVERSITY_OF_TAMPA_TITLE } from '@/pages/areas/university-of-tampa';

export const AreasList = () => {
  return (
    <>
      <li>
        <LinkWithTitle to="/areas/tampa">
          {TAMPA_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/areas/davis-island">
          {DAVIS_ISLAND_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/areas/downtown-tampa">
          {DOWNTOWN_TAMPA_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/areas/university-of-tampa">
          {UNIVERSITY_OF_TAMPA_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/areas/channelside-district">
          {CHANNELSIDE_DISTRICT_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/areas/south-tampa">
          {SOUTH_TAMPA_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/areas/harbour-island">
          {HARBOUR_ISLAND_TITLE}
        </LinkWithTitle>
      </li>
    </>
  );
};
